import Component from '../inherited/Component'
import axios from 'axios'

export default class QuickView extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._popupElem = document.querySelector('[data-quick-view-popup]')
    this._popupContentElem = this._popupElem.querySelector('[data-quick-view-popup-content]')
    this._closeElems = this._popupElem.querySelectorAll('[data-quick-view-popup-close]')
  }

  async mount () {
    this._elem.addEventListener('click', async e => {
      this._elem.classList.add('button--loading')

      let { data } = await axios.get(`/products/${this._options.handle}?view=quickview`)
      let parser = new DOMParser()
      let html = parser.parseFromString(data, 'text/html')
      let fetchedElem = html.querySelector('[data-quick-view-content]')

      this._popupContentElem.innerHTML = fetchedElem.innerHTML
      this._theme.mountComponents(this._popupContentElem)

      this._ctx.emit('radiant--lazy-load-update')
      this._ctx.emit('radiant--scroll-lock-elem', null, this._popupContentElem)

      this._popupElem.classList.add('shown')
      this._elem.classList.remove('button--loading')
    })

    for (let elem of this._closeElems) {
      elem.addEventListener('click', e => {
        e.preventDefault()
        this._closePopup()
      })
    }

    this._popupElem.addEventListener('click', e => {
      if (e.target === this._popupElem) {
        this._closePopup()
      }
    })

    this._ctx.on('cart-item-added', async () => {
      this._closePopup()
    })

    document.addEventListener('theme--item-added', () => {
      this._closePopup()
    })
  }

  _closePopup () {
    this._popupElem.classList.remove('shown')
    this._ctx.emit('radiant--clear-all-scroll-locks')
  }
}